
<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";

import ReportingCustomerComponent from "../reporting/reporting-customer-component.vue";


/**
 * Reporting component
 */
export default {
  page: {
    title: "Les Rapports",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {Layout,ReportingCustomerComponent},

};
</script>

<template>
  <Layout>
    <ReportingCustomerComponent /> 
  </Layout>
</template>
















